// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import PartRequestsSearchAside from './part-requests-search-aside';
import PartRequestsSearchMain from './part-requests-search-main/';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class PartRequestsSearch extends Component {

    componentWillMount() {

        if (this.props.queryParams.q && this.props.queryParams.by) {

            this.props.actions.updateSearchQueryString(this.props.queryParams.q);
            this.props.actions.updateSearchBy(this.props.queryParams.by);
            this.props.actions.getRequestTypes(this.props.queryParams.q);

        }

    }

    componentWillReceiveProps(nextProps) {

        const newSearch = (nextProps.queryParams.by && nextProps.queryParams.q) && (this.props.queryParams.by !== nextProps.queryParams.by || this.props.queryParams.q !== nextProps.queryParams.q);

        if (newSearch) {

            this.props.actions.updateSearchQueryString(nextProps.queryParams.q);
            this.props.actions.updateSearchBy(nextProps.queryParams.by);
            this.props.actions.updateSearchResults(nextProps.queryParams.q);

        }

    }

    render() {

        return (
            <section className='part-requests-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <PartRequestsSearchAside/>
                <PartRequestsSearchMain/>
            </section>
        );

    }

}

PartRequestsSearch.displayName = 'PartRequestsSearch';
PartRequestsSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    queryParams: PropTypes.object.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default PartRequestsSearch;



// WEBPACK FOOTER //
// ./src/part-requests/search/components/part-requests-search.js